<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class=" p-3 max-h-64 overflow-y-auto w-full z-30 text-xs">
                <div class="space-y-6">
                    <div v-if="results.length > 0">
                        <div class="flex text-xs font-medium text-gray-400 mb-1">
                            <div class="ml-2 flex-grow">Purchase Order Items</div>
                        </div>
                        <div class="space-y-1">
                            <div
                                v-for="purchaseOrder in results"
                                class="flex space-x-2 text-left w-full text-gray-500 pl-2 pr-1 py-0"
                                :title="purchaseOrder.name"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full py-1"
                                         v-text="purchaseOrder.supplier+' '+purchaseOrder.reference"></div>
                                    <div
                                        v-for="item in purchaseOrder.items"
                                        class="flex space-x-2 text-left w-full pl-2 pr-1 py-0"
                                        :title="item.description"
                                    >
                                        <div class="truncate flex-1 flex flex-col text-blue-500">
                                            <div class="truncate w-full">
                                                <div class="truncate text-sms mx-0 py-0.5 px-1">
                                                    <button
                                                        @mousedown="selectItem(purchaseOrder,item, close)"
                                                        class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                                    >
                                                <span class="flex-1 flex flex-grow mx-1 relative truncate">
                                                    <span class="flex-grow truncate"
                                                          v-text="item.line+' - '+item.description+' ('+item.quantity+' '+item.unitOfMeasure+')'">
                                                    </span>
                                                </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(results.length ===0)" class="text-gray-500 text-sm">
                        No items found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {distance} from "fastest-levenshtein";
import {cloneDeep} from "lodash";


export default {
    components: {UiButtonNew, UiDropdown},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        enabled: true,
        purchaseOrders: Array,
        RFMItem: Object,
    },
    data() {
        return {
            results: [],
            search: ''
        }
    },
    watch: {},
    computed: {},
    methods: {
        scope(dropdownScope) {
            return {
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        matchItem(item) {
            if (!this.search || (this.search.trim().length === 0)) {
                return true;
            }
            const query = ('' + this.search).toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (item.poString + ' ' + item.description + ' ' + item.uom).toLowerCase().includes(token)
            });

        },
        buildTree() {
            let tree = [];
            let addToTree = (purchaseOrder, i) => {
                let s = tree.find((i) => i.id === purchaseOrder.id);
                if (!s) {
                    s = {
                        id: purchaseOrder.id,
                        supplier: purchaseOrder.supplier ? purchaseOrder.supplier : "<no supplier>",
                        supplierReference: purchaseOrder.supplierReference,
                        reference: purchaseOrder.fullReference,
                        items: [],
                        minDistance: Infinity
                    }
                    tree.push(s);
                }
                let item = cloneDeep(i);
                item.poString = purchaseOrder.supplier + ' ' + purchaseOrder.fullReference;
                item.distance = distance(item.description + ' (' + item.quantity + ' ' + item.unitOfMeasure + ')', this.RFMItem.material + ' (' + this.RFMItem.quantity + ' ' + this.RFMItem.unitOfMeasure + ')')
                s.minDistance = Math.min(s.minDistance, item.distance)
                s.items.push(item);
            }
            if (this.purchaseOrders) {
                this.purchaseOrders.forEach(purchaseOrder => {
                    purchaseOrder.items.forEach((item, index) => {
                        if (this.matchItem(item)) {
                            item.line = index + 1
                            addToTree(purchaseOrder, item);
                        }
                    })
                })
            }
            tree.forEach((i) => {
                i.items.sort((a, b) => a.distance - b.distance);
            })
            tree.sort((a, b) => a.minDistance - b.minDistance);
            this.results = tree;
        },
        async setQuery(query, open = true) {
            this.search = query
            this.buildTree()
            if (open) {
                this.$refs.dropdown.close();
                this.$refs.dropdown.open();
            }
        },
        async selectItem(purchaseOrder, item, close) {
            this.$emit('selected:item', purchaseOrder, item);
            close();
        },
        clear(close) {
            close();
        },
        close() {
            this.$refs.dropdown.close();
        },
    },
    async mounted() {
        this.buildTree()
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
